<div [ngClass]="isMobile ? 'h-[100vh]' : 'h-[700px] max-h-[700px]'" class="app-container mobile:w-full" #appContainer>
	<div [ngStyle]="getBackgroundColorClass()" class="content" fxLayout="column" #mobileView>
		<div class="menu-header" [ngStyle]="{ 'border-radius': isMobile ? '0' : '24px 24px 0 0' }"></div>
		<div class="heading" fxLayout="column">
			<div class="title" fxLayout="row">
				<svg width="24" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="mdi:hand-wave">
						<path
							id="Vector"
							d="M17.5 0.999884C20.81 0.999884 23.5 3.68988 23.5 6.99988H22C22 4.49988 20 2.49988 17.5 2.49988V0.999884ZM7.5 22.9999C4.19 22.9999 1.5 20.3099 1.5 16.9999H3C3 19.4999 5 21.4999 7.5 21.4999V22.9999ZM4.82 15.9999L9.42 20.5899C12.64 23.8099 17.87 23.8099 21.09 20.5899C24.31 17.3699 24.31 12.1399 21.09 8.91988L14 1.84988C13.53 1.35988 12.74 1.35988 12.25 1.84988C12.1336 1.966 12.0412 2.10394 11.9782 2.2558C11.9152 2.40766 11.8828 2.57047 11.8828 2.73488C11.8828 2.8993 11.9152 3.06211 11.9782 3.21397C12.0412 3.36583 12.1336 3.50377 12.25 3.61988L16.67 8.03988L15.96 8.74988L9.42 2.20988C8.93 1.71988 8.14 1.71988 7.65 2.20988C7.16 2.69988 7.16 3.49988 7.65 3.99988L13.5 9.80988L12.77 10.4999L5.88 3.62988C5.39 3.13988 4.6 3.13988 4.11 3.62988C3.62 4.11988 3.62 4.90988 4.11 5.39988L11 12.2899L10.3 12.9999L4.82 7.49988C4.33 6.99988 3.54 6.99988 3.05 7.49988C2.56 7.99988 2.56 8.77988 3.05 9.26988L10.67 16.8899C11.4396 16.2932 12.4004 15.9976 13.3723 16.0584C14.3442 16.1191 15.2606 16.5321 15.95 17.2199L15.24 17.9299C14.6775 17.3681 13.915 17.0525 13.12 17.0525C12.325 17.0525 11.5625 17.3681 11 17.9299L10.65 18.2799L6.58 14.2099C6.09 13.7199 5.3 13.7199 4.81 14.2099C4.33 14.7099 4.33 15.4999 4.82 15.9999Z"
							fill="#FBD354"
							style="fill: #fbd354; fill: color(display-p3 0.9843 0.8275 0.3294); fill-opacity: 1"
						/>
					</g>
				</svg>
				<h1>{{ 'welcome' | translate }}</h1>
			</div>
			<ng-template #defaultSub>
				<p *ngIf="!newFollow" class="sub-title">Jotts are timely messages that you can privately react to.</p>
			</ng-template>
		</div>

		<div fxFlex fxLayout="column" class="channel-content" #channelContent [style.maxHeight]="maxHeight">
			<div fxFlex fxLayout="column" class="channel">
				<div class="image-container">
					<div class="image-outer-border">
						<img [style.height]="imageHeight" [style.width]="imageHeight" [src]="channel?.image?.url || channelImage || './assets/images/default.png'" class="image2" />
					</div>
				</div>
			</div>
		</div>

		<div class="channel-name" fxLayout="row">
			<h1>
				<b>{{ channel?.name }}</b>
			</h1>
		</div>

		<div class="info-desk mb-[32px]">
			<h3 class="text-center">{{ 'jottoMakesEasy' | translate }}</h3>
		</div>

		<div class="action relative" fxLayout="column">
			<button *ngIf="!formLoading" class="proceed-button font-black animate-pulse text-center w-[150px] h-[36px]" (click)="registerUser()"
                    [disableRipple]="true">{{ 'lets_go' | translate }}</button>
			<button color="accent" *ngIf="formLoading" class="proceed-button-loader p-0 text-center w-[150px] h-[36px]" isEnabled="false" [disableRipple]="true" mat-flat-button>
				<mat-spinner color="primary" [diameter]="24"></mat-spinner>
			</button>
            <b class="absolute text-xs bottom-[24px] text-[var(--portals-theme-accent)]" *ngIf="channel.disclaimer">{{channel.disclaimer}}<br /></b>
			<span *ngIf="this.currentLanguage === 'en'" [style.margin]="channel.disclaimer ? '24px auto 8px' : '16px auto 16px'">
				By clicking
				<b>LET'S GO</b>
				you agree to the {{ environment.whiteLabel || 'Jotto' }}
				<a class="policy" routerLink="/policies/terms">Terms</a>
				and
				<a class="terms" routerLink="/policies/privacy">Privacy Policy</a>
			</span>
			<span *ngIf="this.currentLanguage === 'es'" [style.margin]="channel.disclaimer ? '24px auto 8px' : '16px auto 16px'">
				Al hacer clic en
				<b>VAMOS</b>
				aceptas los
				<a class="policy" routerLink="/policies/terms">Términos</a>
				de {{ environment.whiteLabel || 'Jotto' }} y la
				<a class="terms" routerLink="/policies/privacy">Privacidad</a>
			</span>
		</div>

		<div *ngIf="scrollable" class="flex justify-center items-center bg-portals-theme-on-primary w-full">
			<button mat-icon-button (click)="moveToGray()">
				<mat-icon class="mb-[15px]">keyboard_arrow_down</mat-icon>
			</button>
		</div>
	</div>
</div>
